import React from 'react';
import { useSite } from '@edreamsodigeo/frontend-core';
import { DateTime as PrismaDateTime } from '@edreamsodigeo/prisma-design-system';

export const DateTime = (props) => {
  const site = useSite();
  const format = !props.format && site === 'US' ? 'h:mm aa' : props.format;
  return <PrismaDateTime {...props} format={format} />;
};

export const DateFormat = (props) => {
  const site = useSite();
  let format;

  if (!props.format) {
    if (site === 'US') {
      format = props.withWeekDay ? 'EEE, LLL dd' : 'LLL dd';
    } else {
      format = props.withWeekDay ? 'EEE, d MMM' : 'd MMM';
    }
  }
  return <PrismaDateTime {...props} format={format} type="date" />;
};
